import Bowser from "bowser";

function getPlatform() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return null;

  let os: Platform = "mac";
  const { userAgent } = navigator;
  if (userAgent.includes("Mac")) os = "mac";
  if (userAgent.includes("Win")) os = "windows";
  if (userAgent.includes("Linux")) os = "linux";
  if (userAgent.includes("Android")) os = "android";
  if (userAgent.includes("iP") || userAgent.includes("iPhone") || userAgent.includes("like Mac")) {
    os = "iphone";
  }
  return os;
}

function getPlatformValue<T>(values: { desktop?: T; iphone?: T; android?: T; fallback?: T }): T {
  let platform: Platform | "desktop" | null = getPlatform();
  if (platform === "mac" || platform === "windows" || platform === "linux") platform = "desktop";
  return (values[platform || "desktop"] || values.fallback) as T;
}

function isMobile() {
  const platform = getPlatform();
  if (platform === "android" || platform === "iphone") {
    return true;
  }
  return false;
}

function isMobileView(breakpoint = 767) {
  if (typeof window === "undefined") return false;
  const mobileView = window.matchMedia(`only screen and (max-width: ${breakpoint}px)`).matches;
  return Boolean(mobileView);
}

let browserParser: unknown = null;

export const Platform = Object.freeze({
  isMobileView,
  getPlatform,
  getPlatformValue,
  get isMobile() {
    return isMobile();
  },
  get browser() {
    if (!browserParser) browserParser = Bowser.getParser(window.navigator.userAgent);
    return browserParser as ReturnType<typeof Bowser.getParser>;
  }
});
